import { render } from "./HomePreguntas.vue?vue&type=template&id=eec6984a"
import script from "./HomePreguntas.vue?vue&type=script&lang=js"
export * from "./HomePreguntas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__